import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const devPath = process.env.REACT_APP_I18N_DEV_PATH;

declare module 'i18next' {
  interface CustomTypeOptions {
    returnNull: false;
  }
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    returnNull: false,
    backend: {
      loadPath: `${devPath === '1' ? '' : '/maf-final-terms'}/locales/{{lng}}/{{ns}}.json`,
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    defaultNS: 'translation',
  });

export default i18n;
